/**
 * Open Bets 页面配置常量
 * 集中管理所有可配置的参数，方便调整和维护
 */

/** Tickets 列表相关配置 */
export const TICKETS_CONFIG = {
  /** 每页数量 */
  PAGE_SIZE: 100,
  /** 自动刷新间隔（毫秒） */
  REFRESH_INTERVAL: 30000,
  /** 支持的投注类型 */
  BET_TYPES: ['SINGLE', 'COMBO', 'CUSTOM', 'OUTRIGHT', 'SYSTEM'] as const,
} as const;

/** Cashout 金额轮询相关配置 */
export const CASHOUT_POLLING_CONFIG = {
  /** 轮询间隔（毫秒） */
  POLLING_INTERVAL: 60000 * 5, // 5分钟
  /** 防抖延迟（毫秒）- 进入可视区域后延迟多久开始查询 */
  DEBOUNCE_DELAY: 300,
} as const;

/** IntersectionObserver 相关配置 */
export const OBSERVER_CONFIG = {
  /** 提前加载的边距（像素） */
  ROOT_MARGIN: '100px',
  /** 触发阈值（0 表示完全离开视口才触发 onHidden，任意可见即触发 onVisible） */
  THRESHOLD: 0,
} as const;
